export async function deleteFromStorage(key: string): Promise<void>{
  localStorage.removeItem(key);
}

export async function clearStorage(): Promise<void>{
  localStorage.clear();
}

export async function storeInStorage(key: string, data: any): Promise<void>{
  localStorage.setItem(key, JSON.stringify(data));
}

export async function loadFromStorage(key: string): Promise<any | null>{
  const data = localStorage.getItem(key);
  if(data){
    try{
      const parsedData = JSON.parse(data);
      if(parsedData && Object.keys(parsedData).length > 0){
        return parsedData;
      }
      return null;
    }
    catch(e){
      return data;
    }
  }
  return null;
}